export enum MobileWebviewCommunicationActions {
    AppForeground = 'app_foreground',
    AppBackground = 'app_background',
    BackButtonPressed = 'back_button_pressed',
    GameStarted = 'game_started',
    LobbyLoaded = 'lobby_loaded',
    OrientationPortrait = 'orientation_portrait',
    OrientationLandscape = 'orientation_landscape',
    Resize = 'resize',
    ShareLink = 'room_link',
    ShareImage = 'share_image',
    RequestNotificationPermission = 'request_notification_permission',
    NotificationSetExternalUserId = 'notification_set_external_user_id',
    RequestReview = 'request_review',
    ShowTextNotification = 'show_text_notification',
    ShowTopBottomSafeArea = 'show_top_bottom_safe_area',
    ShowSplashScreen = 'should_show_splash_screen',
    AppEncounteredError = 'app_encountered_error',
    PurchaseProduct = 'purchase_product',
    GiftMembership = 'gift_membership',
    PurchaseMembership = 'purchase_membership',
    LocalizedPricingSubscriptions = 'localized_pricing_subscriptions',
    LocalizedPricingProducts = 'localized_pricing_products',
    UserCancelledPurchase = 'user_cancelled_purchase',
    ShowManageSubscriptions = 'show_manage_subscriptions',

    BannerAd = 'banner_ad',
}

export interface BannerAdPayload {
    id: string
    x: number
    y: number
    width: number
    height: number
    visible: boolean
}
export interface PurchaseProductPayload {
    productId: string
    userId: string
}

export interface GiftMembershipPayload {
    productId: string
    metadataId: string
}

export interface PurchaseMembershipPayload {
    subscriptionId: string
    userId: string
    offerToken: string
}

export interface ShareDataPayload {
    title: string
    message: string
    url: string
}

export interface ShareImagePayload {
    title: string
    imageSrc: string
}

/* eslint-disable @typescript-eslint/indent */
export type MobileWebviewCommunicationActionType<T extends MobileWebviewCommunicationActions> =
    T extends MobileWebviewCommunicationActions.ShareLink ? ShareDataPayload | string :
    T extends MobileWebviewCommunicationActions.ShareImage ? ShareImagePayload :
    T extends MobileWebviewCommunicationActions.ShowTextNotification ? string :
    T extends MobileWebviewCommunicationActions.AppEncounteredError ? string :
    T extends MobileWebviewCommunicationActions.PurchaseProduct ? PurchaseProductPayload :
    T extends MobileWebviewCommunicationActions.GiftMembership ? GiftMembershipPayload :
    T extends MobileWebviewCommunicationActions.PurchaseMembership ? PurchaseMembershipPayload :
    T extends MobileWebviewCommunicationActions.BannerAd ? BannerAdPayload :
    T extends MobileWebviewCommunicationActions.NotificationSetExternalUserId ? string :
    T extends MobileWebviewCommunicationActions.ShowManageSubscriptions ? string :
    boolean

export function isTwoWayCommunicationAction(action: string): action is MobileWebviewCommunicationActions {
    return Object.values(MobileWebviewCommunicationActions).includes(action as MobileWebviewCommunicationActions)
}
